import { images } from './images';

export type SocialPlatform = 'instagram' | 'facebook' | 'tiktok' | 'youtube' | 'linkedin' | 'snapchat';

// Placeholder profile links — replace with the official ES World handles before launch.
export const socialLinks: { platform: SocialPlatform; label: string; href: string }[] = [
  { platform: 'instagram', label: 'Instagram', href: 'https://www.instagram.com/' },
  { platform: 'facebook', label: 'Facebook', href: 'https://www.facebook.com/' },
  { platform: 'tiktok', label: 'TikTok', href: 'https://www.tiktok.com/' },
  { platform: 'youtube', label: 'YouTube', href: 'https://www.youtube.com/' },
  { platform: 'linkedin', label: 'LinkedIn', href: 'https://www.linkedin.com/' },
  { platform: 'snapchat', label: 'Snapchat', href: 'https://www.snapchat.com/' },
];

export const socialFeedIntro =
  'At ES World, we make studying a fun and fascinating experience for every student. A family-like atmosphere in a culturally diverse community at our school is our asset. Our school will become your second home while you learn, discover, and enjoy!';

// Placeholder feed posts — swap in real Instagram images.
export const socialPosts: { image: string; alt: string }[] = [
  { image: images.classroom, alt: 'Students in a classroom' },
  { image: images.london, alt: 'Students in London' },
  { image: images.social, alt: 'Students on a city walk' },
  { image: images.campusLife, alt: 'Students outside the school' },
  { image: images.speaking, alt: 'Students practising speaking' },
  { image: images.dubai, alt: 'Dubai skyline' },
  { image: images.young, alt: 'Young learners in class' },
  { image: images.oxfordshire, alt: 'Summer camp in Oxfordshire' },
  { image: images.teacher, alt: 'A teacher with students' },
  { image: images.newYork, alt: 'Students in New York' },
  { image: images.accommodation, alt: 'A student room' },
  { image: images.losAngeles, alt: 'Students in Los Angeles' },
  { image: images.tokyo, alt: 'Students in Tokyo' },
  { image: images.seoul, alt: 'Students in Seoul' },
  { image: images.hongKong, alt: 'Students in Hong Kong' },
  { image: images.hero, alt: 'Students laughing in the lounge' },
];
